import { AxiosError } from 'axios';
import { ConsigneeInterface, IApproval, IBarCodeDelete, IBooking, IBulkPrint, IConsigneePhoneUpdate, ICustomerBookingRequest, IGetTrayBarcode, IOriginDestinationRequest, IProofOfDeliveryRequest, IShipper, IShipperAndAccountDetailRequest, IShipperRequestInterface, IValidAgreementDetailRequest } from '../model/BookingModel';
import AjexPortalService from "./api";
import config from './config';
import { getNotificationStyle } from '../common/notification';
import { UploadFormData } from '../stores/common';
import { IFileUpload } from '../model/CommonModel';

const cpBooking = config.get('cpBooking');
const customer = config.get('customer');
const product = config.get('product');
const productIdQuery = config.get('productId');
const subProductIdQuery = config.get('subProductId');
const subProduct = config.get('subProduct');
const temperature = config.get('temperature');
const shipper = config.get('shipper');
const customerSubAccount = config.get('customerSubAccount');
const consignee = config.get('consignee');
const clientSubId = config.get('clientSubId');
const cancel = config.get('cancel')
const subCLientIdQuery = config.get('subCLientIdQuery')
const subClientQuery = config.get('subClientQuery')
const tree = config.get('tree');
const podFileOptions = config.get('podFileOptions');
const pod = config.get('pod');
const countryCity = config.get('countryCity');
const tracking = config.get('tracking');
const vehicle = config.get('vehicle');
const podFiles = config.get('podFiles');
const download = config.get('download');
const boxSeal = config.get('boxSeal');
const accountInfo = config.get('accountInfo');
const booking = config.get('booking');
const updateTrayPieceBarcode = config.get('updateTrayPieceBarcode');
const customerBooking = config.get('customerBooking');
const trayBarcode = config.get('trayBarcode');
const excelBulkBooking = config.get('excelBulkBooking');
const trayPieceBarcode = config.get('trayPieceBarcode');
const getTrayPieceBarcode = config.get('getTrayPieceBarcode');
const cityConsignee = config.get('cityConsignee');
const city = config.get('city');
const consigneeConfirmLs = config.get('consigneeConfirmLs');
const cityShipper = config.get('cityShipper');
const newManualSticker = config.get('newManualSticker');
const print = config.get('print');
const newManualWaybill = config.get('newManualWaybill');
const createNewShipper = config.get('createNewShipper');
const createNewConsignee = config.get('createNewConsignee');
const productDescription = config.get('productDescription');
const occ = config.get('occ');


const bookingURL = process.env.REACT_APP_TMS_INTEGRATION_BOOKING_SERVICE;
const commonURL = process.env.REACT_APP_TMS_INTEGRATION_COMMON_SERVICE;
const readURL = process.env.REACT_APP_TMS_READ_SERVICE;
const occURL = process.env.REACT_APP_TMS_OCC_SERVICE;
const tmsPricingService = process.env.REACT_APP_TMS_PRICING_SERVICE;

///cpBooking?pageNumber=1&pageSize=1
export const GetBookingListService = async (pageNumber: number, pageSize: number, data: Partial<ICustomerBookingRequest>) => {
    try {
        //?${index}=${pageNumber}&${count}=${pageSize}
        return await AjexPortalService.post(`${cpBooking}/filter`, data)
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const GetCustomerByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${customer}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const GetSubProductByIdService = async (id: number, subClientId: number) => {
    try {
        return await AjexPortalService.get(`${subProduct}?${productIdQuery}=${id}&${subCLientIdQuery}=${subClientId}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const GetProductsService = async (subId: number) => {
    try {
        return await AjexPortalService.get(`${product}/${subClientQuery}/${subId}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const GetTemperatureByIdService = async (productId: number, subProductId: number, subClientId: number) => {
    try {
        return await AjexPortalService.get(`${temperature}/sub-product?${productIdQuery}=${productId}&${subProductIdQuery}=${subProductId}&${subCLientIdQuery}=${subClientId}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const GetShipperDetailsByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${bookingURL}${shipper}/${clientSubId}/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError;

        return err?.response
    }
}

export const GetConsigneeDetailsByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${bookingURL}${consignee}/${clientSubId}/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError;

        return err?.response
    }
}
export const SaveBookingService = async (data: IBooking) => {
    try {
        return await AjexPortalService.post(`${cpBooking}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}


export const SaveShipperService = async (data: IShipperRequestInterface) => {
    try {
        return await AjexPortalService.post(`${bookingURL}${shipper}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const SaveConsigneeService = async (data: IShipperRequestInterface) => {
    try {
        return await AjexPortalService.post(`${bookingURL}${consignee}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const GetBookingDetailByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${cpBooking}/${id}`,)
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const UpdateBookingDetailService = async (id: number | undefined, data: IBooking) => {
    try {
        return await AjexPortalService.put(`${cpBooking}/${id}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const CancelBookingByIdService = async (id: number | undefined, data?: { cancelReasonId: null, cancelRemarks?: undefined, feedback?: undefined }) => {
    try {
        return await AjexPortalService.put(`${cpBooking}/${cancel}/${id}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const GetAccountNameByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${customerSubAccount}/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response
    }
}


export const GetBookingDetailsService = async (id: number) => {
    try {
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1/product/tree/20
        return await AjexPortalService.get(`${bookingURL}${product}/${tree}/${id}`)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const GetProofOfDeliveryService = async () => {
    try {
        //pod-file-options
        return await AjexPortalService.get(`${commonURL}${podFileOptions}`)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const SaveProofOfDeliveryService = async (data: IProofOfDeliveryRequest) => {
    try {
        //pod-file-options
        return await AjexPortalService.post(`${bookingURL}${pod}`, data)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }

}

export const DeleteProofOfDeliveryService = async (id: number | undefined) => {
    try {
        //pod-file-options
        return await AjexPortalService.delete(`${bookingURL}${pod}/${id}`,)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const GetOriginDestinationCountryCityService = async (request: IOriginDestinationRequest) => {
    try {
        return await AjexPortalService.post(`${bookingURL}${countryCity}`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const TrackWayBillService = async (airWayBillNumber: string) => {
    try {
        // old
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1/vehicle/tracking/A1010000714
        // return await AjexPortalService.get(`${bookingURL}${vehicle}/${tracking}/${airWayBillNumber}`,)
        // New
        // https://apps.aj-ex.com/tms-occ-service/api/v1/occ/tracking/A1090018491
        return await AjexPortalService.get(`${occURL}${occ}/${tracking}/${airWayBillNumber}`,)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const DownloadPodFileService = async (id: number | undefined) => {
    try {
        return await AjexPortalService.get(`${commonURL}${podFiles}/${download}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UserStatusService = async (customerId: string | number | undefined) => {
    try {
        return await AjexPortalService.get(`${bookingURL}/${booking}/${accountInfo}/${customerId}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const DownloadFileService = async (airWayBillNumber: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}file-attachment/${download}/${boxSeal}/${airWayBillNumber}`,)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const UpdateBarcodeService = async (request: any, paramsId: number | undefined) => {
    try {
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1/booking/update-tray-piece-barcode/1218
        return await AjexPortalService.put(`${bookingURL}/${booking}/${updateTrayPieceBarcode}/${paramsId}`, request)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const DeleteTrayBarCodeService = async (request: Omit<IBarCodeDelete, 'trayPieceBarCodeId'>) => {
    try {
        // tray-piece-barcode
        return await AjexPortalService.delete(`${bookingURL}/${booking}/${trayBarcode}`, { data: request })
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const DeleteTrayPieceBarCodeService = async (request: IBarCodeDelete) => {
    try {
        // tray-piece-barcode
        return await AjexPortalService.delete(`${bookingURL}/${booking}/${trayPieceBarcode}`, { data: request })
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const GetTrayBarCodeService = async ({ bookingId, trayId }: IGetTrayBarcode) => {
    try {
        //http://localhost:6200/api/v1/booking/get-tray-piece-barcode/{trayId}/{bookingId}
        return await AjexPortalService.get(`${bookingURL}/${booking}/${getTrayPieceBarcode}/${trayId}/${bookingId}`)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const GetBarCodeService = async (id: number) => {
    try {
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1/booking/tray-piece-barcode/1220
        return await AjexPortalService.get(`${bookingURL}/${booking}/${trayPieceBarcode}/${id}`)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const DownloadBookingExcelService = async () => {
    try {
        return await AjexPortalService.get(`${bookingURL}/${customer}/${download}/${customerBooking}.xlsx`)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const UploadBulkBooingService = async (file: Omit<IFileUpload, 'clientSubId' | 'fileTypeId'>, isUploadBooking: boolean) => {
    try {
        const { formData, configuration } = UploadFormData(file, isUploadBooking)
        return await AjexPortalService.post(`${bookingURL}/${customer}/${excelBulkBooking}`, formData, configuration)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetConsigneeDetailsByShipperAndAccountDetailsService = async (request: IShipperAndAccountDetailRequest) => {
    try {
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1/city/city-consignee
        return await AjexPortalService.post(`${bookingURL}/${city}/${cityConsignee}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}
export const ConsigneeApprovalService = async (request: IApproval) => {
    try {
        ;
        //https://apps-sit.aj-ex.com/tms-common-service/api/v1/consignee-confirm-ls
        return await AjexPortalService.post(`${commonURL}${consigneeConfirmLs}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}
export const UpdateConsigneeApprovalService = async (request: IApproval) => {
    try {
        ;
        //https://apps-sit.aj-ex.com/tms-common-service/api/v1/consignee-confirm-ls
        return await AjexPortalService.put(`${commonURL}${consigneeConfirmLs}/${request?.id}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
export const GetConsigneeApprovalByIdService = async (id: number) => {
    try {
        //https://apps-sit.aj-ex.com/tms-common-service/api/v1/consignee-confirm-ls
        return await AjexPortalService.get(`${commonURL}${consigneeConfirmLs}/booking-id/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const GetShipperDetailsByAccountDetailsService = async (request: Partial<Omit<IShipperAndAccountDetailRequest, 'originCityId'>>) => {
    try {
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1/city/city-consignee
        return await AjexPortalService.post(`${bookingURL}${city}/${cityShipper}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}

export const PrintBulkWayBillService = async (waybills: IBulkPrint) => {
    try {
        //https://apps.aj-ex.com/tms-read-service/api/v1/print/new-manual-waybill
        return await AjexPortalService.post(`${readURL}/${print}/${newManualWaybill}`, waybills)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
export const PrintBulkStickerService = async (waybills: IBulkPrint) => {
    try {
        //https://apps-sit.aj-ex.com/tms-common-service/api/v1/print/new-waybill-sticker
        return await AjexPortalService.post(`${commonURL}/${print}/${newManualSticker}`, waybills)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/shipper/3
export const GetShipperByIdService = async (id: number | undefined) => {
    try {
        return await AjexPortalService.get(`${bookingURL}/${shipper}/${id}`)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/consignee/10
export const GetConsigneeByIdService = async (id: number | undefined) => {
    try {
        return await AjexPortalService.get(`${bookingURL}/${consignee}/${id}`)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
//POST:https://apps-sit.aj-ex.com/tms-booking-service/api/v1/shipper/create-new-shipper/10
export const UpdateShipperByIdService = async (request: Partial<IShipper>, id: number | undefined) => {
    try {
        ;
        return await AjexPortalService.post(`${bookingURL}/${shipper}/${createNewShipper}/${id}`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

//POST: https://apps-sit.aj-ex.com/tms-booking-service/api/v1/consignee/create-new-consignee/10
export const UpdateConsigneeByIdService = async (request: Partial<ConsigneeInterface>, id: number | undefined) => {
    try {
        return await AjexPortalService.post(`${bookingURL}/${consignee}/${createNewConsignee}/${id}`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/product-description/download?productId=5
export const ProductDescriptionByProductIdService = async (request: number) => {
    try {
        return await AjexPortalService.get(`${bookingURL}${productDescription}/${download}?${productIdQuery}=${request}`)
    } catch (error) {
        const err = error as AxiosError;
        // getNotificationStyle(err?.response);
        return err?.response
    }
}

// tms-booking-service/api/v1/consignee/update-consignee/
export const UpdateConsigneePhoneNumberService = async (request: IConsigneePhoneUpdate, id: number) => {
    try {
        return await AjexPortalService.put(`${bookingURL}consignee/update-consignee/${id}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

export const GetValidAgreementDetailService = async (request: IValidAgreementDetailRequest) => {
    try {
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1//find-valid-agreement-detail
        return await AjexPortalService.post(`${bookingURL}booking/find-valid-agreement-detail`, request)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const GetCommodityListService = async (request: IValidAgreementDetailRequest) => {
    try {
        //https://apps-sit.aj-ex.com/tms-pricing-service/api/v1/commodity/agreement-commodity
        return await AjexPortalService.post(`${tmsPricingService}commodity/agreement-commodity`, request)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}